<template>
  <el-dialog
    @open="onOpen"
    :title="tituloDialog"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="40%"
  >
    <el-form :model="conta" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Status" prop="status">
            <el-select v-model="conta.status" value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in statusConta" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="Tipo" prop="tipo">
            <el-select v-model="conta.tipo" value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in tipos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="Banco" prop="banco">
            <el-select v-model="conta.banco" value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in bancos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Titular" prop="titular">
            <el-input v-model="conta.titular"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="cpfCnpjTitular" label="CPF/CNPJ Titular">
            <el-input
              auto-complete="off"
              v-model="conta.cpfCnpjTitular"
              v-mask="maskCpfCnpj"
              placeholder="Informe o CPF ou CNPJ"
            />
            <small v-if="conta.cpfCnpjTitular" class="form-text-small" :style=" exibirAlertaCpfInvalido ?  'visibility: visible' : 'visibility: hidden; margin-bottom: -25px'">* CPF inválido.</small>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Agência" prop="agencia">
            <el-input v-model="conta.agencia"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="Díg.">
            <el-input v-model="conta.digitoAgencia" maxlength="1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Conta" prop="conta">
            <el-input v-model="conta.conta"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="Díg.">
            <el-input v-model="conta.digitoConta" maxlength="1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Operação">
            <el-input v-model="conta.operacao"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Pix">
            <el-input v-model="conta.pix" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gravar()" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BANCOS, STATUS_CONTA, TIPO_CONTA } from '../../../util/constantes.js';
import Util from "../../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    contaASerAlterada: Object
  },
  data() {
    return {
      validacao: {
        status: [
          { required: true, message: "Status é obrigatório" },
        ],
        tipo: [
          { required: true, message: "Tipo é obrigatório" },
        ],
        banco: [
          { required: true, message: "Banco é obrigatório" },
        ],
        titular: [
          { required: true, message: "Titular é obrigatório" },
        ],
        agencia: [
          { required: true, message: "Agência é obrigatório" },
        ],
        conta: [
          { required: true, message: "Conta é obrigatório" },
        ],
        cpfCnpjTitular: [{ validator: this.validadorCpfCnpj, required: false }],
      },
      conta: {
        status: "",
        agencia: "",
        digitoAgencia: "",
        conta: "",
        digitoConta: "",
        titular: "",
        operacao: "",
        pix: "",
        banco: "",
        tipo: "",
        cpfCnpjTitular: "",
        cliente: {
          id: 0,
        }
      }
    }
  },
  computed: {
    ...mapState('vendasClientesStore', {
      cliente(state) { return state.clienteSelecionado }
    }),
    bancos() { 
      return BANCOS;
    },
    tipos() { 
      return TIPO_CONTA;
    },
    statusConta() { 
      return STATUS_CONTA;
    },
    isCriacao() {
      return this.contaASerAlterada === undefined;
    },
    tituloDialog() {
      if(this.isCriacao) return 'Nova Conta Bancária'
      else return 'Editar Conta Bancária'
    },
    maskCpfCnpj() {
      return this.conta.cpfCnpjTitular ? (this.conta.cpfCnpjTitular.length <= 14 ? "###.###.###-###" : "##.###.###/####-##")  : "" ;
    },
    exibirAlertaCpfInvalido(){
      return !Util.validarCpf(this.conta.cpfCnpjTitular) && this.conta.cpfCnpjTitular.length === 14;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('vendasClientesStore', [
      'gravarConta'
    ]),
    onOpen() {
      this.verificarAlteracao();
    },
    reset() {
      this.conta = {
        agencia: "",
        digitoAgencia: "",
        conta: "",
        digitoConta: "",
        titular: "",
        status: "",
        operacao: "",
        pix: "",
        banco: "",
        tipo: "",
        cpfCnpjTitular: "",
        cliente: {
          id: 0,
        }
      }
    },
    cpfIsValido(cpf) {
      return Util.validarCpf(cpf);
    },

    cnpjIsValido(cnpj) {
      if (!cnpj) return false;

      return cnpj.length === 18;
    },

    validadorCpfCnpj(rule, value, callback) {
      if(!value || !value.trim()) {
        return callback();
      }
      if (this.cpfIsValido(value) || this.cnpjIsValido(value)) {
        return callback();
      } 
      return callback(new Error());      
    },
    gravar() {
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.preencherCliente();
          this.showLoading();
          this.gravarConta(this.conta)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          }).catch(() => {
            this.hideLoading();
          });
        } else {
          this.$message.warning("Preencha todos os campos obrigatórios");
        }
      })
    },
    verificarAlteracao() {
      const isAlteracao = this.contaASerAlterada !== undefined;
      if(isAlteracao) {
        this.conta = Object.assign({}, this.contaASerAlterada);
      }
    },
    preencherCliente() {
      this.conta.cliente = { id : this.cliente.id };
    },
    
    fechar() {
      this.reset();
      this.$refs.form.resetFields();
      this.$emit('close');
    },   
  }
}
</script>

<style scoped>
.form-item {
    width: 100%; 
}
.select {
  font-size: 50%;
}
.form-text-small{
  color: rgb(245, 108, 108);;
  margin-top: -8px;
  margin-bottom: -10px;
  display: block;
}
</style>